<template>
  <section class="lm-column" @click="$emit('click')">
    <section class="lm-column_content" v-if="src"><img style="height: 283px;" class="is_block" :src="src" /></section>
    <section class="lm-column_text">
      <section class="lm-column_title">{{ title }}</section>
      <section class="lm-column_intro">{{ description }}</section>
      <section
        class="lm-column_link is_link"
        v-for="(item, i) in links"
        :key="i"
        @click="artilceIdArticle(item.id, item.article_url)"
      >{{ item.article_title }}</section>
    </section>
  </section>
</template>

<style scoped lang="scss">
.lm-column {
  cursor: pointer;
}
.lm-column_content {
  background-color: rgb(231, 231, 231);
  margin-bottom: 19px;
}
.lm-column_title {
  margin-bottom: 9.728px;
  line-height: 29.6875px;
  font-size: 23.75px;
  font-weight: 700;
}
.lm-column_intro {
  margin-bottom: 9.728px;
  line-height: 30.2812px;
  font-size: 19px;
}
.lm-column_link {
  color: rgb(0, 85, 145);
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; 
}
</style>

<script>
import { methodsMixins } from '@/mixins/index';

export default {
  mixins: [methodsMixins],
  props: {
    src: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      require: true
    },
    description: {
      type: String,
      require: true
    },
    links: {
      type: Array,
      require: true
    }
  },
  methods: {
    handleToArticle(menu1Id, menu2Id, url) {
      if(url) {
        window.open(url);
        return
      }
      const { origin, pathname } = window.location;
      window.open(origin + pathname + `#/article?menu1Id=${menu1Id}&menu2Id=${menu2Id}`)
    }
  }
}
</script>